export default {
  /** 右メニュー用 */
  activeSidebarForGrid: { mapId: "", isActive: false, menuName: "" },
  allGridMapSettings: [],
  // グリッドマップに表示するポップアップメッセージ
  expiredPopupForGrid: null,
  /** グリッドの追跡監視用 */
  // { mapId: "", center: [] }
  lastTrackingPosition: { mapId: "", center: [] },
};
